import React from 'react'
import './styles.scss'

const SkipLink = () => (
  <a href='#main' className='skip-link visually-hidden'>
    Skip to main content
  </a>
)

export default SkipLink
